import { getAll, create, update, destroy } from 'redux/api/KpiVariables'
import { put } from 'redux/api/SortedKpiVariables'

import { Dispatch } from 'redux'
import { ApplicationState } from 'redux/Stores/types'
import { useThunkActions } from 'redux/actions/useThunkActions'
import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryPutSortedKpiVariables(data: string[]) {
  return (dispatch: Dispatch) => {
    dispatch(actions.putSort())

    put(data)
      .then((response) => {
        dispatch(actions.putSortSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.putSortFailed())
      })
  }
}

function tryGetAllKpiVariables() {
  return (dispatch: Dispatch, getState: () => ApplicationState) => {
    if (getState().KpiVariableStore.fetching) {
      return
    }

    dispatch(actions.getAll())

    getAll()
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryCreateKpiVariable(data: {
  name: string
  level: number
  parent_kpi_variable_id?: string
}) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create({ data })
      .then((response) => {
        dispatch(actions.createSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelCreated))
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelCreatedFailed))
      })
  }
}

function tryUpdateKpiVariable(
  id: string,
  data: { name: string },
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, { data })
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelUpdated))

        callback?.()
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelUpdatedFailed))

        callback?.(true)
      })
  }
}

function tryDeleteKpiVariable(id: string, callback?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess({ id }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelDeleted))

        callback?.()
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.AccountLevelDeletedFailed))

        callback?.(true)
      })
  }
}

export const useKpiVariableActions = () => {
  return {
    tryCreateKpiVariable: useThunkActions(tryCreateKpiVariable),
    tryGetAllKpiVariables: useThunkActions(tryGetAllKpiVariables),
    tryDeleteKpiVariable: useThunkActions(tryDeleteKpiVariable),
    tryPutSortedKpiVariables: useThunkActions(tryPutSortedKpiVariables),
    tryUpdateKpiVariable: useThunkActions(tryUpdateKpiVariable)
  }
}
